import VettedCheckmark from '../src/VettedCheckmark';
export default VettedCheckmark;
